/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-16 08:34:34
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { Card } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import PreviewProduct from 'src/components/views/default-layout-settings/preview-product';

type Props = WithI18nProps;

class Preview extends Component<Props, State> {
  render() {
    const { settingsStyleValues, i18n } = this.props;

    return (
      <div className="previewPanel">
        <Card title={i18n.translate('AdminHTML.DefaultLayoutSettings.Preview.cardTitle')} sectioned>
          <PreviewProduct settings={settingsStyleValues} />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const formDefaultLayoutSettings = getFormValues('DefaultLayoutSettingsForm')(state);

  const settingsStyleValues = _.pick(formDefaultLayoutSettings, [
    'actionlist.alStyle',
    'actionlist.qvEnable',
    'actionlist.atcBtnBackgroundColor',
    'actionlist.atcBtnHoverBackgroundColor',
    'actionlist.atcBtnBorderColor',
    'actionlist.atcBtnHoverBorderColor',
    'actionlist.atcBtnTextColor',
    'actionlist.atcBtnHoverTextColor',
    'actionlist.atcEnable',
    'actionlist.qvBtnBackgroundColor',
    'actionlist.qvBtnHoverBackgroundColor',
    'actionlist.qvBtnBorderColor',
    'actionlist.qvBtnHoverBorderColor',
    'actionlist.qvBtnTextColor',
    'actionlist.qvBtnHoverTextColor'
  ]);

  return {
    settingsStyleValues
  };
};

export default connect(mapStateToProps)(withI18n()(Preview));
